import { selectLastRunnerSelection, useUIStore } from '../stores/uiStore';
import { getDaemonTriggerPreference, saveDaemonTriggerPreference } from './daemonTriggerPreferences';
import type { RunnerRequestSelectionStorage } from './runnerRequest';

export const webRunnerRequestSelection: RunnerRequestSelectionStorage = {
  getRunnerSelection: (projectId: string) => selectLastRunnerSelection(useUIStore.getState(), projectId),
  saveRunnerSelection: (projectId: string, runnerType: string, model: string) =>
    useUIStore.getState().setLastRunnerSelection(projectId, runnerType, model),
  getPreference: getDaemonTriggerPreference,
  savePreference: saveDaemonTriggerPreference,
};
